// extracted by mini-css-extract-plugin
export default {"valid":"VBFeedbackText_valid__gXwQw","invalid":"VBFeedbackText_invalid__kf1p3"};